export default "__VITE_ASSET__979ec286__"